module.exports = __webpack_public_path__ + "01_glasses_black.e886b789.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer4/01_glasses_black.png
// module id = JOGy
// module chunks = 0